import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  DatePicker,
  Select
} from "antd";
import React, { forwardRef, useState, useImperativeHandle,useEffect } from "react";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import dayjs from "dayjs";

const AddModal = forwardRef((props, ref) => {
  const { onSuccess } = props;
 const [propId, setPropId] = useState([]);
  const [select1Value, setSelect1Value] = useState(null);
  const [form] = Form.useForm();
    const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [currentPropId, setCurrentPropId] = useState(null);
  const [selectPropData, setSelectPropData] = useState(null);
  useImperativeHandle(ref, () => ({
    // 父组件调用：addModalRef.current.setModelAdd(record)
    setModelAdd: () => {
      try {
      

        form.resetFields();
        setVisible(true);
            propIdFun("");
      } catch (error) {
        message.error("Failed to initialize modal data");
        console.error("Initialization error:", error);
      }
    },
  }));

    //获取propId
    const propIdFun = async (content, ) => {
      console.log("获取prop");
      try {
 
           const response = await http.get(`${api.getPropSearch}?content=${content}`);
        if (response && response.data) {
          console.log("获取到prpid数据");
          setLoading(false);
          const formattedData = response.data.map((item) => ({
            value: item.propId,
            label: item.propName,
            city: item.city,
            add: item.street,
            prop: item.prop,
          }));
          setPropId(formattedData);
          // if (showId) {
          //   const nowIndex = formattedData.findIndex(
          //     (item) => item.value === showId
          //   );
          //   console.log(formattedData[nowIndex]?.value);
          //   if (index !== -1) setSelect1Value(formattedData[nowIndex]?.value); //找到对象
          // }
        }
      } catch (err) {
        setError(err); // 捕获错误
      } finally {
        //setBtnLoading(false)  // 设置加载状态
      }
    };

    const onPropTypeChange = (value, options) => {
    console.log("点击事件");
    setSelect1Value(value);
    setSelectPropData(options);
  };
  const onTypeSearch = (value, option) => {
    propIdFun(value);
  };
  const onFinishAdd = async (values) => {
    // if (!currentPropId) {
    //   message.error("propId is missing.");
    //   return;
    // }

    try {
      setLoading(true);

      const queryParams = {
        propId: values.propId,
        amount: Number(values.amount),
        date1Ts: values.date1Ts
          ? dayjs(values.date1Ts).startOf("day").valueOf()
          : null,
        date2Ts: values.date2Ts
          ? dayjs(values.date2Ts).startOf("day").valueOf()
          : null,
        invDate1Ts: values.invDate1Ts
          ? dayjs(values.invDate1Ts).startOf("day").valueOf()
          : null,
      };

      console.log("Add Rent GlTran params:", queryParams);

      const response = await http.post(`${api.getAddRentGlTran}`, queryParams);

      if (response.code === "1") {
        message.success("Add successfully");
        setVisible(false);
        form.resetFields();
        onSuccess?.();
      } else {
        message.error(response.msg || "Add failed");
      }
    } catch (error) {
      console.error(error);
      message.error("Submit an error and try again later.");
    } finally {
      setLoading(false);
    }
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            ADD RENT GL TRAN
          </Typography.Title>
        </Flex>
      }
      width="50%"
      open={visible}
      onCancel={() => {
        setVisible(false);
        form.resetFields();
      }}
      footer={[
        <Button
          key="back"
          onClick={() => {
            setVisible(false);
            form.resetFields();
          }}
        >
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => form.submit()}
        >
          Submit
        </Button>,
      ]}
    >
      <Flex justify="space-between" align="flex-start">
        <div className="model_top" style={{ width: "100%" }}>
          <div className="model_content">
            <Form
              {...layout}
              name="addRentGlTranForm"
              onFinish={onFinishAdd}
              form={form}
              labelCol={{
                style: {
                  width: "150px",
                },
              }}
              wrapperCol={{
                style: {
                  flex: 1,
                },
              }}
            >
         <Form.Item
                      name="propId"
                      label="Property"
                      rules={[{ required: true }]}
                      className="mt30"
                    >
                      <Select
                        showSearch
                        allowClear
                        placeholder="Select a prop"
                        onChange={onPropTypeChange}
                        onSearch={onTypeSearch}
                        optionFilterProp="label"
                        value={select1Value}
                        filterOption={false}
                        options={propId}
                      />
                    </Form.Item>
              <Form.Item
                name="amount"
                label="Amount"
                rules={[
                  {
                    required: true,
                    message: "Please enter amount.",
                  },
                ]}
              >
                <Input placeholder="Please enter amount." allowClear />
              </Form.Item>

       
              <Form.Item
                name="date1Ts"
                label="Date 1"
                rules={[
                  {
                    required: true,
                    message: "Please select Date 1.",
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format="YYYY-MM-DD"
                />
              </Form.Item>
              <Form.Item
                name="date2Ts"
                label="Date 2"
                rules={[
                  {
                    required: true,
                    message: "Please select Date 2.",
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format="YYYY-MM-DD"
                />
              </Form.Item>
              <Form.Item
                name="invDate1Ts"
                label="Invoice Date"
                rules={[
                  {
                    required: true,
                    message: "Please select Invoice Date.",
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format="YYYY-MM-DD"
                />
              </Form.Item>
            </Form>
          </div>
        </div>
      </Flex>
    </Modal>
  );
});

export default AddModal;
